/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Could_Not_Restore_PurchasesInputs */

const en_plan_could_not_restore_purchases = /** @type {(inputs: Plan_Could_Not_Restore_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not restore purchases right now. Please try again.`)
};

const es_plan_could_not_restore_purchases = /** @type {(inputs: Plan_Could_Not_Restore_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos restaurar las compras ahora. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We could not restore purchases right now. Please try again." |
*
* @param {Plan_Could_Not_Restore_PurchasesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_could_not_restore_purchases = /** @type {((inputs?: Plan_Could_Not_Restore_PurchasesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Could_Not_Restore_PurchasesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_could_not_restore_purchases(inputs)
	return en_plan_could_not_restore_purchases(inputs)
});